/**
 * @fileoverview Entity Picker main interface
 */
// @ts-nocheck
goog.declareModuleId('yext.ui.components.entitypicker.EntityPickerController');

import {DropdownTrigger} from '/ui/components/dropdowntrigger/dropdowntrigger';
import {SingleSelectContainer} from '/ui/components/entitypicker/container/singleselectcontainer';

import {EntityPickerControllerProps, EntityPickerControllerCore} from './entitypickercontroller-core';
export class EntityPickerController extends EntityPickerControllerCore {
  constructor(props) {
    super({
      ...props,
      DefaultTrigger: DropdownTrigger,
      SingleSelectContainer: SingleSelectContainer,
    });

    /** @type {EntityPickerControllerProps} */
    this.props;
  }
}
